module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAIVBMVEUAAAD////////////////////////////////////////PIev5AAAACnRSTlMAkm3UFhVu0xCfgGqORQAAAHNJREFUKM9jgAJWBwZUEGyCymexWgxXIigoyMDgvGqVCZTJsGrVKqACq+VAJUAmSCAticF5cdTSKhOGtDSQABBzWJVyLQhe3ADiQPD0AK4FrJUMCAEOBq4FDA1IAgwgAQY6C0DA8BQQRAJgAWQAElBCAQwAXtBGKrSojbEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/upload_icon.png
// module id = /nyn
// module chunks = 2